import axios from 'axios'
  // const baseUrl = 'http://127.0.0.1:8000/api'

 // const baseUrl = 'https://staging.imsynapse.com/api'
//  const baseUrl = 'https://admin.imsynapse.com/api'
//  const baseUrl = 'https://dev.imsynapse.com/api'
 const baseUrl = 'https://admin.uksynapse.com/api'

/** Origin without `/api`, e.g. for `/profile/...` assets. */
export function apiOrigin() {
  return String(baseUrl).replace(/\/api\/?$/, '');
}

export function assetUrl(path) {
  if (!path) return '';
  const p = String(path);
  if (/^https?:\/\//i.test(p) || p.startsWith('data:') || p.startsWith('blob:')) return p;
  return `${apiOrigin()}/${p.replace(/^\//, '')}`;
}

export function get(url, params) {
    return axios({
        method: 'GET',
        url: baseUrl+url,
        params: params
    })
}

export function byMethod(method, url, data) {
    return axios({
        method: method,
        url: baseUrl+url,
        data: data
    })
}
